import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { DialogHandlerService } from '../../services/dialog-handler/dialog-handler.service';
import { JoinService } from '../../services/join/join.service';
import { UserDataService } from '../../services/user-data/user-data.service';
import { RoutePaths } from '../../../shared/constants/route-paths.constant';
import { DriverStatusEnum } from '../../../shared/constants/driver-status.constant';

@Component({
    standalone: false,
    selector: 'octo-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    userSummary$ = new Subscription();
    userData$ = new Subscription();
    userSummary: any;
    isLoggedin: boolean = false;
    showNav: boolean = false;
    currentURL = '';
    isSignup = false;
    status: any;
    shortName: any;
    isAdmin: any;
    isBonus: boolean = false;

    @Input() isOctopusApp: boolean = false;
    @Input() showHeader: boolean = true;
    @Input() isOrderTracking: boolean = false;

    constructor(
        private readonly userDataService: UserDataService,
        private readonly authService: AuthenticationService,
        private readonly joinService: JoinService,
        private readonly router: Router,
        private readonly dialogService: DialogHandlerService
    ) {}

    initialize(): void {
        this.isAdmin = localStorage.getItem('isAdmin') === 'true';
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((val: any) => {
                this.currentURL = val.urlAfterRedirects;
                this.isBonus =
                    this.currentURL.includes(RoutePaths.JOIN) ||
                    this.currentURL.includes(RoutePaths.PROFILE) ||
                    this.currentURL.includes(RoutePaths.INFO) ||
                    this.currentURL.includes(RoutePaths.PAYMENT) ||
                    this.currentURL.includes(RoutePaths.PROOF_OF_RIDES) ||
                    this.currentURL.includes(RoutePaths.UBER_CONNECT_REQUIRED);
                this.status = localStorage.getItem('status');
                this.isSignup =
                    this.currentURL.includes('dashboard') ||
                    this.currentURL.includes('my-account') ||
                    this.currentURL.includes('link-uber');
                this.isLoggedin = !!(this.authService.getToken() && this.status?.toLowerCase?.() !== 'undefined');

            });

        if (this.authService.getToken() || this.isAdmin) {
            this.userSummary$ = this.userDataService
                .getUserSummary()
                .subscribe((data: any) => {
                    if (data) {
                        if (!data?.profile_image)
                            this.shortName =
                                data?.first_name.charAt(0).toUpperCase() +
                                ' ' +
                                data?.last_name.charAt(0).toUpperCase();
                        this.status = data?.status;
                        this.userSummary = {
                            image_url: data?.profile_image,
                            first_name: data?.first_name,
                            last_name: data?.last_name,
                            email: data?.email,
                            status: this.status,
                            texted_logs: data?.texted_logs,
                        };
                    }
                });
        }
        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                if (!data?.profile_image)
                    this.shortName =
                        data?.first_name.charAt(0).toUpperCase() +
                        ' ' +
                        data?.last_name.charAt(0).toUpperCase();
                this.status = data?.status;
                this.userSummary = {
                    image_url: data?.profile_image,
                    first_name: data?.first_name,
                    last_name: data?.last_name,
                    email: data?.email,
                    status: this.status,
                    texted_logs: data?.texted_logs,
                };
            });
    }

    ngOnInit(): void {
        this.initialize();
    }

    ngOnDestroy(): void {
        this.userSummary$.unsubscribe();
        this.userData$.unsubscribe();
    }

    tosWarning(): void {
        const driverStatus = localStorage.getItem('status'),
            isTosAccepted = localStorage.getItem('isTosAccepted');
        if (
            isTosAccepted === 'false' &&
            (
                driverStatus === DriverStatusEnum.APPROVED ||
                driverStatus === DriverStatusEnum.INTERESTED_DNQ_OTHER ||
                driverStatus === DriverStatusEnum.INTERESTED_DNQ_MARKET ||
                driverStatus === DriverStatusEnum.INTERESTED_DNQ_RIDES
            )
        ) {
            this.joinService.setUserError({
                isLogin: false,
                noAccess: false,
                isLocked: false,
                isReset: false,
                resetSuccess: false,
                isLogout: false,
                invalidLogin: false,
                showTos: true,
            });
        } else this.router.navigate([RoutePaths.LOGIN]);
    }

    toggleMenu(): void {
        this.showNav = !this.showNav;
    }

    logout(): void {
        this.authService.logOut();
        this.dialogService
            .confirmAction(
                {
                    title: 'Success!',
                    message: 'You were logged out. Bye!',
                },
                false
            )
            .subscribe((data) =>
                globalThis.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                })
            );
    }

    gotoCurrentPage(): void {
        this.router.navigate([RoutePaths.ROOT_PATH]);
    }
}
